/* src/app/features/naturezas-juridicas-aceitas/pesquisa/naturezas-juridicas-aceitas-pesquisa.component.scss */
/*# sourceMappingURL=naturezas-juridicas-aceitas-pesquisa.component.css.map */
